var React = require('react');

function SmsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.659 7.997V0H0V14.394H7.997V22.391H19.06L23.325 26.655H23.99V22.391H26.656V7.997H18.659ZM1.066 13.328V1.066H17.593V7.997H7.997V13.328H1.066ZM25.59 21.325H22.924V24.747L19.501 21.325H9.062V9.063H25.589V21.325H25.59Z","fill":"#555555"}));
}

SmsIcon.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = SmsIcon;

SmsIcon.default = SmsIcon;
